export default class AtmosphereEngine {
  constructor() {
    this.state = {
      fog: 0,
      glow: 0.22,
      pulse: 0.5
    }
  }

  update(appState, vibes, deltaTime, time) {
    const selectedFactor = Math.min(1, appState.selectedVibeIds.length / 3)
    const hoverFactor = appState.hoveredVibeId ? 0.15 : 0
    const densityFactor = Math.min(1, vibes.length / 40)
    const pulse = 0.5 + Math.sin(time * 0.35 + deltaTime * 10) * 0.5

    this.state.fog = 0
    this.state.glow = 0.14 + densityFactor * 0.05 + selectedFactor * 0.18 + hoverFactor + pulse * 0.04
    this.state.pulse = pulse
  }

  getState() {
    return this.state
  }
}
